import { useUpgrade } from '../context/UpgradeContext'
import { planFor } from '../plans'
import { FEATURES, type FeatureKey } from '../types'
import { LockIcon } from './icons'
import './LockedNote.css'

/**
 * Ayarlarda paketinde olmayan bölümün yerine (29 Eki 2026): ne olduğunu ve
 * hangi pakette olduğunu söyler, "Ayrıntı" yükseltme penceresini açar.
 */
export function LockedNote({ feature }: { feature: FeatureKey }) {
  const askUpgrade = useUpgrade()
  const spec = FEATURES.find((f) => f.key === feature)
  const plan = planFor(feature)
  return (
    <div className="locked-note">
      <span className="locked-note__icon" aria-hidden="true">
        <LockIcon />
      </span>
      <div className="locked-note__text">
        <b>{plan ? `${plan.name} paketinde` : 'Ek modül'}</b>
        <span>{spec?.description}</span>
      </div>
      <button type="button" className="btn btn--outline" onClick={() => askUpgrade(feature)}>
        Ayrıntı
      </button>
    </div>
  )
}
